import PropTypes from 'prop-types'
import { Controller, useFormContext } from 'react-hook-form'
import {
  Typography,
  FormGroupContainer,
  FormLabelStyled,
  FormControlStyled,
  FormTextAreaStyled,
  FormTextStyled,
} from '../styled'

export default function Input({
  name,
  label,
  type,
  placeholder,
  helperText,
  required,
  as,
  fontSize: _fontSize,
  ...rest
}) {
  const { control } = useFormContext()
  const ControlComponent =
    as === 'textarea' ? FormTextAreaStyled : FormControlStyled

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => (
        <FormGroupContainer>
          {label ? (
            <FormLabelStyled>
              <Typography size="12px">
                {label}
                {required && <span className="text-danger">*</span>}
              </Typography>
            </FormLabelStyled>
          ) : null}
          <ControlComponent
            isInvalid={!!fieldState.error}
            onChange={field.onChange}
            type={type}
            value={field.value}
            placeholder={placeholder}
            as={as}
            {...rest}
          />
          <FormTextStyled isError={!!fieldState.error}>
            {fieldState.error ? fieldState.error.message : helperText}
          </FormTextStyled>
        </FormGroupContainer>
      )}
    />
  )
}

Input.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  helperText: PropTypes.string,
  required: PropTypes.bool,
  as: PropTypes.string,
  fontSize: PropTypes.string,
}

Input.defaultProps = {
  placeholder: '',
  helperText: '',
  required: false,
  type: 'text',
  as: 'input',
  fontSize: '12px',
}
